import { useCallback } from 'react'
import { useEoValue } from '~/src/hooks/useEoState'
import routesEnum from '~/src/router/enums/routes.enum'
import { FIRM_SELECTOR } from '~/src/stores/firm'
import { IS_MARKETPLACE_SELECTOR } from '~/src/stores/brand'
import { useParams } from 'react-router-dom'

interface ReturnsType {
  resolve(path: string): string,
}

const useFirmPathResolver = (): ReturnsType => {
  const firm = useEoValue(FIRM_SELECTOR)
  const params = useParams()
  const isMarketplace = useEoValue(IS_MARKETPLACE_SELECTOR)

  const resolve = useCallback((path: string): string => {
    if (path === routesEnum.FIRM_HOME) {
      if (params.shopName) {
        return `/${params.shopName}/${params.lang}${routesEnum.MENU}`
      }

      if (isMarketplace) {
        return `/${params.lang}${routesEnum.EXPLORER}`
      }

      return `/${params.lang}${routesEnum.MENU}`
    }

    if (params.shopName) {
      return `/${params.shopName}/${params.lang}${path}`
    }

    return `/${params.lang}${path}`
  }, [ params, firm ])

  return { resolve }
}

export {
  useFirmPathResolver
}
